import {PhoneNumberUtil} from 'libphonenumber';

const PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber'
};

class ContactsSummaryTable {
    constructor(InsuranceSuiteMetadata, $filter, ContactService) {
        this._InsuranceSuiteMetadata = InsuranceSuiteMetadata;
        this._translateRole = name => $filter('translate')(`gateway.contacts.common.views.roles.${name}`);
        this._contactsService = ContactService;
    }

    $onInit() {
        this._rolesTypeList = this._InsuranceSuiteMetadata.get('pc').types.getTypelist('AccountContactRole');
        this.roleOptions = this._rolesTypeList.codes
            .filter(c => c.code !== 'AccountContactRole') // Removes abstract entity AccountContactRole
            .map(c => {
                return {name: this._translateRole(c.code), code: c.code};
            });

        this.selectedContactRole = null;
        this.resetQuery();
    }

    getPrimaryPhoneNumber(contact) {
        const phoneNumber = contact[PRIMARY_PHONE_TYPE_MAP[contact.primaryPhoneType]];
        const phoneUtils = PhoneNumberUtil.getInstance();

        if (!phoneNumber) return null;
        try {
            return phoneUtils.format(phoneUtils.parse(phoneNumber, this._defaultLocaleDetails.countryCode));
        } catch (e) {
            return phoneNumber;
        }
    }

    // noinspection JSUnusedGlobalSymbols
    getRoleName(roleCode) {
        return this.roleOptions.find(opt => opt.code === roleCode).name;
    }

    resetQuery() {
        return this.loadContacts(0, this.pageSize);
    }

    loadContacts(toPage, pageSize) {
        const currentPage = toPage;
        const roleFilter = this.selectedContactRole ? [this.selectedContactRole] : [];
        this.loaded = false;

        return this._contactsService.getAccountContacts(this.accountNumber, roleFilter, currentPage, pageSize)
            .then((data) => {
                this.contacts = data.accountContacts;
                this.firstContact = currentPage * pageSize;
                this.currentPage = currentPage;
                this.totalContacts = data.maxNumberOfResults;
                this.loaded = true;
            });

    }
}

ContactsSummaryTable.$inject = ['InsuranceSuiteMetadata', '$filter', 'ContactService'];

export default ContactsSummaryTable;